import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductData, Product } from '../../classes/product';
import { ValidatorsService } from '../../services/validators.service';
import { AuthService } from '../../services/auth.service';
import { ProductsService } from '../../services/products.service';
import { DialogService } from '../../services/dialog.service';
import { StorageService } from '../../services/storage.service';
import { DatabaseService } from '../../services/database.service';
import { SnackbarService } from '../../services/snackbar.service';
import { FileInput } from 'ngx-material-file-input';

@Component({
  selector: 'app-new-product',
  templateUrl: './new-product.component.html',
  styleUrls: ['./new-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewProductComponent implements OnInit {

	@Input('product') product : Product;

	@Input('confirm') confirm : Function;
	@Input('close') close : Function;
	@Input('errorMessage') errorMessage : string;

	@Input() loading : boolean;
	@Output() loadingChange = new EventEmitter<boolean>();

	setLoading(value: boolean) {
		this.loading = value;
		this.loadingChange.emit(this.loading);
	}


	saving : boolean = false;


	form : FormGroup;

	constructor(private formBuilder: FormBuilder,
				private validatorsService: ValidatorsService,
				private productsService: ProductsService,
				private dialogService: DialogService,
				private storageService: StorageService,
				private database: DatabaseService,
				private snackbar: SnackbarService,
				private authService: AuthService) {

	}

	ngOnInit() {

		if (this.product)
		{
			this.form = this.formBuilder.group({
				title: [this.product.title, [Validators.required]],
				description: [this.product.description, [Validators.required]],
				date: [this.product.date, []],
				expiration: [this.product.expiration, []],
				file: [null, []]
			});
		}
		else
		{
			this.form = this.formBuilder.group({
				title: [null, [Validators.required]],
				description: [null, [Validators.required]],
				date: [null, []],
				expiration: [null, []],
				file: [null, []]
			});
		}
	}


	get extension() : string {

		if (this.product && this.product.file)
		{
			return this.product.file.substring(this.product.file.lastIndexOf('.') + 1).toUpperCase();
		}
		else
		{
			return '';
		}
	}


	download() {

		this.storageService.downloadFile(this.product.file, this.product.title);
	}


	deleteFileDialog() {

		this.dialogService.openDialog({
			type: 'Warn',
			title: 'Eliminar archivo',
			text: '¿Seguro que desea eliminar este archivo? Esta acción no se puede deshacer.',
			confirm: this.deleteFile.bind(this)
		});
	}

	deleteFile() {

		this.storageService.deleteFile(this.product.file).then(result => {

			this.product.file = null;

			this.productsService.set(this.product).finally(() => {
				this.dialogService.closeDialog();
				this.snackbar.show("Archivo eliminado");
			});
		}).catch(reason => {
			this.snackbar.show("Error al eliminar el archivo");
		});
	}


	save() {

		if (this.form.invalid)
		{
			Object.keys(this.form.controls).forEach(key => {
				this.form.controls[key].markAsTouched();
			});
			
			return;
		}

		this.saving = true;


		const fileInput : FileInput = this.form.get('file').value;

		const productID : string = this.product ? this.product.id : this.database.createID();

		const product : Product = {
			id: productID,
			title: this.form.get('title').value,
			description: this.form.get('description').value,
			date: this.form.get('date').value,
			expiration: this.form.get('expiration').value,
			file: this.product ? this.product.file : null
		};


		if (fileInput && fileInput.files && fileInput.files.length > 0)
		{
			const file = fileInput.files[0];
			const extension = file.name.substring(file.name.lastIndexOf('.'));

			const path : string = 'Products/'+productID+extension;

			this.storageService.uploadFile(path, file).then(result => {

				product.file = path;

				this.productsService.set(product).then(result => {
					this.dialogService.closeDialog();
				}).catch(() => {
					this.saving = false;
				});

			}).catch(reason => {

				this.snackbar.show('Error al subir archivo');
				this.saving = false;
			});
		}
		else
		{
			this.productsService.set(product).then(result => {
				this.dialogService.closeDialog();
			}).catch(() => {
				this.saving = false;
			});
		}
	}

}
